import { type ReactNode, useMemo } from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { CompanyDateAdapter } from "./CompanyDateAdapter";
import { useThemeStore } from "@/stores/theme";
import { createAppTheme } from "./theme";
import { enUS } from "date-fns/locale";

export function AppThemeProvider({ children }: { children: ReactNode }) {
  const isDark = useThemeStore((s) => s.theme === "dark");
  const theme = useMemo(
    () => createAppTheme(isDark ? "dark" : "light"),
    [isDark],
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      <LocalizationProvider
        dateAdapter={CompanyDateAdapter}
        adapterLocale={enUS}
      >
        {children}
      </LocalizationProvider>
    </ThemeProvider>
  );
}
